export default function toTwoDecimals(input: number) {
  return Math.round(parseFloat(String(input)) * 100) / 100;
}
